import _ from 'lodash';
import { setTitle } from 'Utils';
import template from './reports.html';

export default {
  name: 'reports',
  template,
  controller: ReportsController,
  controllerAs: 'ReportsCtrl'
};


/* @ngInject */
function ReportsController($state, $location) {
  const vm = this;
  const params = {
    // TODO: Flatten this object
    // Assigning the params from query like this is more flexible than predefining all possible params in config
    queryParams: _.assign($state.params, $location.search())
  };

  vm.queryParams = params.queryParams;
  vm.route = params.queryParams.type;
  vm.defaultTableOptions = {
    page: 1,
    count: 10,
    sorting: { eventDate: 'desc' },
    filter: {}
  };

  vm.$onInit = initializeReport;
  vm.replaceParams = replaceParams;
  vm.setExtremeTimes = setExtremeTimes;

  /**
   * Initializes the options object with selected equipment id and sets the proper
   * start and end dates in the case that this route was supplied those query params from
   * a url produced by the deeplink method.
   */
  function initializeReport() {
    replaceParams(_.keys(vm.queryParams));
    // default states for init
    let _childDefaultStartDate = null;
    let _childDefaultEndDate = null;

    // expecting start to be the UTC timestamp
    if (vm.queryParams.start && _.isNumber(parseInt(vm.queryParams.start, 10))) {
      _childDefaultStartDate = new Date(parseInt(vm.queryParams.start, 10));
    } else {
      _childDefaultStartDate = new Date();
      setExtremeTimes(_childDefaultStartDate, null);
      const minusDate = 7;
      _childDefaultStartDate.setDate(_childDefaultStartDate.getDate() - minusDate);
    }

    if (vm.queryParams.end && _.isNumber(parseInt(vm.queryParams.end, 10))) {
      _childDefaultEndDate = new Date(parseInt(vm.queryParams.end, 10));
    } else {
      _childDefaultEndDate = new Date();
      setExtremeTimes(null, _childDefaultEndDate);
    }

    vm.dateRangeCollapsed = true;

    vm.options = {
      selectedEquipmentId: vm.queryParams.equipment || '',
      date: {
        start: _childDefaultStartDate,
        end: _childDefaultEndDate
      }
    };

    setTitle(`${vm.route} Report`, true);
  }

  // steps through the possible deep-linked elements from url and removes them to keep the url 'pretty'
  function replaceParams(pars) {
    _.forEach(pars, (param) => {
      $location.search(param, null).replace();
    });
  }

  function setExtremeTimes(start, end) {
    if (start) {
      start.setHours(0, 0, 0, 0);
    }
    if (end) {
      const hours = 23;
      const minSec = 59;
      const milli = 999;
      end.setHours(hours, minSec, minSec, milli);
    }
  }
}
